<template>
  <div>
    <!--面包屑导航区域-->
    <div class="board">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item>系统配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--卡片视图-->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-size: 18px; font-weight: bold;">系统配置管理</span>
      </div>

      <!-- 订单超时配置 -->
      <el-card class="config-card" shadow="never">
        <div slot="header">
          <i class="el-icon-time" style="margin-right: 5px;"></i>
          <span>订单超时设置</span>
        </div>

        <el-form :model="configForm" label-width="200px">
          <el-form-item label="订单超时时间（分钟）">
            <el-input-number
              v-model="configForm.orderTimeoutMinutes"
              :min="1"
              :max="60"
              controls-position="right"
              :precision="0">
            </el-input-number>
            <span style="margin-left: 10px; color: #666; font-size: 14px;">
              设置用户下单后的付款超时时间，范围1-60分钟
            </span>
          </el-form-item>
        </el-form>

        <div style="margin-top: 20px;">
          <el-button type="primary" @click="saveOrderTimeoutConfig" :loading="saving" v-has="712">
            <i class="el-icon-check"></i>
            保存配置
          </el-button>
          <el-button @click="resetOrderTimeoutConfig">
            <i class="el-icon-refresh"></i>
            重置
          </el-button>
        </div>
      </el-card>

      <!-- 票房刷新间隔配置 -->
      <el-card class="config-card" shadow="never" style="margin-top: 20px;">
        <div slot="header">
          <i class="el-icon-refresh" style="margin-right: 5px;"></i>
          <span>票房刷新设置</span>
        </div>

        <el-form :model="configForm" label-width="200px">
          <el-form-item label="票房刷新间隔（秒）">
            <el-input-number
              v-model="configForm.boxOfficeRefreshInterval"
              :min="10"
              :max="300"
              controls-position="right"
              :precision="0">
            </el-input-number>
            <span style="margin-left: 10px; color: #666; font-size: 14px;">
              设置票房排行榜自动刷新间隔，范围10-300秒
            </span>
          </el-form-item>
        </el-form>

        <div style="margin-top: 20px;">
          <el-button type="primary" @click="saveBoxOfficeRefreshConfig" :loading="saving" v-has="712">
            <i class="el-icon-check"></i>
            保存配置
          </el-button>
          <el-button @click="resetBoxOfficeRefreshConfig">
            <i class="el-icon-refresh"></i>
            重置
          </el-button>
        </div>
      </el-card>

      <!-- 手续费费率配置 -->
      <el-card class="config-card" shadow="never" style="margin-top: 20px;">
        <div slot="header">
          <i class="el-icon-coin" style="margin-right: 5px;"></i>
          <span>手续费费率设置</span>
        </div>

        <el-form :model="configForm" label-width="200px">
          <el-form-item label="手续费费率（%）">
            <el-input-number
              v-model="configForm.feeRate"
              :min="0"
              :max="10"
              :precision="2"
              controls-position="right">
            </el-input-number>
            <span style="margin-left: 10px; color: #666; font-size: 14px;">
              设置支付手续费费率，范围0%-10%
            </span>
          </el-form-item>
        </el-form>

        <div style="margin-top: 20px;">
          <el-button type="primary" @click="saveFeeRateConfig" :loading="saving" v-has="712">
            <i class="el-icon-check"></i>
            保存配置
          </el-button>
          <el-button @click="resetFeeRateConfig">
            <i class="el-icon-refresh"></i>
            重置
          </el-button>
        </div>
      </el-card>

      <!-- 配置记录部分已隐藏 -->
    </el-card>
  </div>
</template>

<script>
export default {
  name: "SystemConfig",
  data() {
    return {
      configForm: {
        orderTimeoutMinutes: 2,
        boxOfficeRefreshInterval: 30,
        feeRate: 1
      },
      originalOrderTimeout: 2,
      originalBoxOfficeRefreshInterval: 30,
      originalFeeRate: 1,

      saving: false
    }
  },
  created() {
    this.getOrderTimeoutConfig()
    this.getBoxOfficeRefreshConfig()
    this.getFeeRateConfig()
  },
  methods: {
    async getOrderTimeoutConfig() {
      try {
        const { data: res } = await axios.get('sysConfig/order.timeout.minutes')
        if (res.code === 200 && res.data) {
          this.configForm.orderTimeoutMinutes = parseInt(res.data.configValue)
          this.originalOrderTimeout = parseInt(res.data.configValue)
        }
      } catch (error) {
        console.error('获取订单超时配置失败:', error)
        // 使用默认值
        this.configForm.orderTimeoutMinutes = 2
        this.originalOrderTimeout = 2
      }
    },

    async getBoxOfficeRefreshConfig() {
      try {
        const { data: res } = await axios.get('sysConfig/boxoffice.refresh.interval')
        if (res.code === 200 && res.data) {
          this.configForm.boxOfficeRefreshInterval = parseInt(res.data.configValue)
          this.originalBoxOfficeRefreshInterval = parseInt(res.data.configValue)
        }
      } catch (error) {
        console.error('获取票房刷新间隔配置失败:', error)
        // 使用默认值
        this.configForm.boxOfficeRefreshInterval = 30
        this.originalBoxOfficeRefreshInterval = 30
      }
    },

    async saveOrderTimeoutConfig() {
      if (this.configForm.orderTimeoutMinutes < 1 || this.configForm.orderTimeoutMinutes > 60) {
        this.$message.error('订单超时时间必须在1-60分钟之间')
        return
      }

      this.saving = true
      try {
        const config = {
          configKey: 'order.timeout.minutes',
          configValue: this.configForm.orderTimeoutMinutes.toString(),
          configDesc: '订单超时时间（分钟）',
          configType: 'NUMBER'
        }

        const { data: res } = await axios.put('sysConfig', config)
        if (res.code === 200) {
          this.$message.success('配置保存成功')
          this.originalOrderTimeout = this.configForm.orderTimeoutMinutes
        } else {
          this.$message.error('配置保存失败：' + res.message)
        }
      } catch (error) {
        this.$message.error('配置保存失败')
        console.error('保存配置失败:', error)
      } finally {
        this.saving = false
      }
    },

    async saveBoxOfficeRefreshConfig() {
      if (this.configForm.boxOfficeRefreshInterval < 10 || this.configForm.boxOfficeRefreshInterval > 300) {
        this.$message.error('票房刷新间隔必须在10-300秒之间')
        return
      }

      this.saving = true
      try {
        const config = {
          configKey: 'boxoffice.refresh.interval',
          configValue: this.configForm.boxOfficeRefreshInterval.toString(),
          configDesc: '票房排行榜刷新间隔（秒）',
          configType: 'NUMBER'
        }

        const { data: res } = await axios.put('sysConfig', config)
        if (res.code === 200) {
          this.$message.success('配置保存成功')
          this.originalBoxOfficeRefreshInterval = this.configForm.boxOfficeRefreshInterval
        } else {
          this.$message.error('配置保存失败：' + res.message)
        }
      } catch (error) {
        this.$message.error('配置保存失败')
        console.error('保存配置失败:', error)
      } finally {
        this.saving = false
      }
    },

    resetOrderTimeoutConfig() {
      this.configForm.orderTimeoutMinutes = this.originalOrderTimeout
      this.$message.info('已重置为原始值')
    },

    resetBoxOfficeRefreshConfig() {
      this.configForm.boxOfficeRefreshInterval = this.originalBoxOfficeRefreshInterval
      this.$message.info('已重置为原始值')
    },

    async getFeeRateConfig() {
      try {
        const { data: res } = await axios.get('sysConfig/payment.fee.rate')
        if (res.code === 200 && res.data) {
          this.configForm.feeRate = parseFloat(res.data.configValue)
          this.originalFeeRate = parseFloat(res.data.configValue)
        }
      } catch (error) {
        console.error('获取手续费费率配置失败:', error)
        // 使用默认值
        this.configForm.feeRate = 1
        this.originalFeeRate = 1
      }
    },

    async saveFeeRateConfig() {
      if (this.configForm.feeRate < 0 || this.configForm.feeRate > 10) {
        this.$message.error('手续费费率必须在0%-10%之间')
        return
      }

      this.saving = true
      try {
        const config = {
          configKey: 'payment.fee.rate',
          configValue: this.configForm.feeRate.toString(),
          configDesc: '支付手续费费率（%）',
          configType: 'NUMBER'
        }

        const { data: res } = await axios.put('sysConfig', config)
        if (res.code === 200) {
          this.$message.success('配置保存成功')
          this.originalFeeRate = this.configForm.feeRate
        } else {
          this.$message.error('配置保存失败：' + res.message)
        }
      } catch (error) {
        this.$message.error('配置保存失败')
        console.error('保存配置失败:', error)
      } finally {
        this.saving = false
      }
    },

    resetFeeRateConfig() {
      this.configForm.feeRate = this.originalFeeRate
      this.$message.info('已重置为原始值')
    }
  }
}
</script>

<style scoped>
.board {
  margin-bottom: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.config-card {
  margin-bottom: 0;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-input-number {
  width: 150px;
}

.el-table {
  font-size: 14px;
}
</style>
